export default "__VITE_PUBLIC_ASSET__80919c0f__"